var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require('@/assets/img/hld.png'),"alt":""}}),_c('p',[_vm._v("为了更好的定位您的职业发展，请您完成“霍兰德测评”")]),_c('van-button',{attrs:{"type":"danger"},on:{"click":_vm.hldtest}},[_vm._v("开始测试")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }